export const SET_LOGIN = 'SET_LOGIN';
export const SET_USERID = 'SET_USERID';
export const SET_USERNAME = 'SET_USERNAME';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_LASTNAME = 'SET_LASTNAME';
export const SET_COMPANYIDS = 'SET_COMPANYIDS';
export const SET_USERTOKEN = 'SET_USERTOKEN';
export const SET_USERROLES = 'SET_USERROLES';
export const SET_SUBSCRIBERUNIQUEID = 'SET_SUBSCRIBERUNIQUEID';
export const SET_ISSUBSCRIBERADMIN = 'SET_ISSUBSCRIBERADMIN';
export const SET_ISFLAGSTONEADMIN = 'SET_ISFLAGSTONEADMIN';
export const LOGOUT = 'LOGOUT';

